import React, { Component } from 'react';

class Layout extends Component {
  render() {
    return (
      <div className="App">
        <header className="App-header">
          <h1 className="App-title"><a href="/">EATLIC</a></h1>
        </header>
        <main>
          {this.props.children}
        </main>

        <footer className="App-footer">Built with &hearts; in LIC</footer>
      </div>
    )
  }
}

export default Layout



// WEBPACK FOOTER //
// ./src/components/Layout.js